import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  analysisLandingForPath,
  captureAnalysisEntry,
} from "@/config/analysisOffer";

/** Capture campaigns on editorial entry pages even if no analysis CTA is mounted. */
export function useAnalysisAcquisition() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    captureAnalysisEntry(
      /^\/en(?:\/|$)/.test(pathname) ? "en" : "sv",
      analysisLandingForPath(pathname),
      "analysis_contextual",
      search,
    );
  }, [pathname, search]);
}
